import React, {Fragment} from 'react';

export default {
    PROJECTS_PROJECT_Jinxed: {
        LOGLINE: <Fragment>
            <p>
                The two crooks Chris Brokowski and William Dyno are some real unlucky fellow.<br />
                There are real problems that destroy their dream of the big money.
            </p>
            <p>
                And now their goal is:<br />
                To get out of this alive...
            </p>
        </Fragment>,
        TRIVIA: [
            'There is not only a German version of Jinxed, but also an English version.'
        ]
    },
    PROJECTS_PROJECT_Eine_INM_Weihnachtsgeschichte: {
        LOGLINE: <Fragment>
            <p>
                Merry christmas 2015!
            </p>
        </Fragment>
    },
    PROJECTS_PROJECT_The_Dosshouse_3: {
        LOGLINE: <Fragment>
            <p>
                See what the Dosshouse Killer is all about...<br />
                See how it all began!
            </p>
        </Fragment>,
        TRIVIA: [
            'The classic opening credits are retained',
            'At 2:35 in the movie, "Ice Cold Killers" is on TV'
        ]
    },
    PROJECTS_PROJECT_Christmas_carols_and_stuff: {
        LOGLINE: <Fragment>
            <p>
                Merry christmas 2012!
            </p>
        </Fragment>,
        TRIVIA: [
            'In the police computer you will find Dean Wood but also the Dosshouse Killer (The Dosshouse), Thomas Crone and Francis Payne (100.000 To Live Longer), and Santa Claus',
            'In the browser of the police computer the page of R* Games, the WikINM, and a porn site are bookmarked'
        ]
    },
    PROJECTS_PROJECT_The_Chase: {
        LOGLINE: <Fragment>
            <p>
                The Chase... The video for the short versions of "Dark Chase" and "Chased Till Dawn".
            </p>
            <p>
                It's about a person who receives a phone call.
                The call comes from a phone booth located opposite the person's house.
                Since the person has locked himself out after looking outside the house, he drives away.
                The chase begins.
            </p>
            <p>
                The whole thing is accompanied by the two songs "Dark Chase" and later "Chased Till Dawn".
            </p>
        </Fragment>,
        TRIVIA: [
            'The Chase is the first film that contains only selfmade produced music',
            'The film itself consists only of "Dark Chase" and "Chased Till Dawn"',
            'There is no "talking"',
            'The person\'s license plate has "NOTDONE" written on it, the maniac\'s license plate has "K1l73R"'
        ]
    },
    PROJECTS_PROJECT_Ice_Cold_Killers: {
        LOGLINE: <Fragment>
            <p>
                After the Los Santos police seized 10 tons of cocaine during a raid on Los Santos' port,
                the corrupt cop Shaun Reynolds reports to the leaders of the two biggest drug rings in the city,
                Jerome 'Big Jay' Reever and Richard 'Richie' Kellard.
            </p>
            <p>
                He's offering them a deal that they should have turned down...
            </p>
        </Fragment>,
        TRIVIA: [
            'The basic idea for the film came in April 2009 (even before Restless Survivors), but it was never realized until a competition was launched. The prizes were roles for the film "Ice Cold Killers", which was finally to be produced',
            'The film was released on 12/31/2011, but had to be removed due to YouTube Content ID filter hits, which delayed the release by over a week. This resulted in a total of 4 versions of the film, which only differ in one or two music titles'
        ]
    },
    PROJECTS_PROJECT_28_Hours_Before_Christmas: {
        LOGLINE: <Fragment>
            <p>
                Albert Finnegeon's ultimate christmas carol...
            </p>
        </Fragment>,
        TRIVIA: [
            'The film was almost completely improvised'
        ]
    },
    PROJECTS_PROJECT_Zed_2_Recommended_Gateway: {
        LOGLINE: <Fragment>
            <p>
                Tony Zachery is on his way to Las Venturas with his chauffeur in his limousine, when Pete - the chauffeur - suddenly disappears. Tony realizes that the city is deserted...
            </p>
        </Fragment>,
        TRIVIA: [
            'The film was made - like its predecessor - completely in one weekend (story, scenes, editing and postproduction)'
        ]
    },
    PROJECTS_PROJECT_100000_To_Live_Longer: {
        LOGLINE: <Fragment>
            <p>
                Thomas Crone...<br />
                Has debts...<br />
                To dangerous guys...<br />
                He needs money...<br />
                Is he becoming a murderer?<br />
                You decide!
            </p>
        </Fragment>,
        TRIVIA: [
            '100.000 To Live Longer is an interactive film',
            'The film has 16 alternative endings',
            'The film has a total length of 4 hours, 5 minutes and 2 seconds',
            'The work on the film began on 04/02/2011',
            'In the movie a lot of minor details were taken into account, e.g. the muzzles of weapons - which actually don\'t exist - were added to the movie as a black circle, furthermore there are places where you can look into houses from the outside through doors/windows, which is actually not possible in the game',
            'There are sentences in the film that you only understand when you watch the film several times and decide differently at some points',
            'The technical effort for this film was very high'
        ]
    },
    PROJECTS_PROJECT_Rolling_Dope_2: {
        LOGLINE: <Fragment>
            <p>
                Dean Simmons and Brian O'Neil are being held against their will.
                Can they escape and call the police?
            </p>
        </Fragment>,
        TRIVIA: [
            'The film starts right at the open end of "Rolling Dope"'
        ]
    },
    PROJECTS_PROJECT_What_The_Government_Denies: {
        LOGLINE: <Fragment>
            <p>
                The government... They know... They're the only ones who can know...
            </p>
        </Fragment>,
        TRIVIA: [
            'The film was only made because wesone wanted to publish UFO montages. From the individual montages a whole film was created',
            'At Jay\'s Diner, Dexter\'s coffee cup says "INM entertainment"',
            'At 6:05 in the movie, "The Dosshouse" is on TV',
        ]
    },
    PROJECTS_PROJECT_Eine_Splatter_Weihnachtsgeschichte: {
        LOGLINE: <Fragment>
            <p>
                Tom LeeRoy's ultimate christmas carol...
            </p>
        </Fragment>,
        TRIVIA: [
            'The film is a Christmas-splatter-horror-comedy'
        ]
    },
    PROJECTS_PROJECT_Zed_Last_Time_On_Earth: {
        LOGLINE: <Fragment>
            <p>
                On the way to an important business meeting, Anthony Zagson's private jet crashes. Anthony survives the crash. He finds himself in an unknown place.
            </p>
        </Fragment>,
        TRIVIA: [
            'The film was made completely in one weekend (story, scenes, editing and postproduction)'
        ]
    },
    PROJECTS_PROJECT_The_Dosshouse_2: {
        LOGLINE: <Fragment>
            <p>
                Bob and Fred are on their way in a Taxi to their friend Dave.
                They have planned Dave's bachelor party and want to surprise him with a visit to a strip club in Las Venturas.
                They come to a bar that's for sale.
            </p>
            <p>
                The three friends decide to buy the bar and their nightmare begins...
            </p>
        </Fragment>,
        TRIVIA: [
            'The opening credits closely resemble the opening credits of "The Dosshouse"',
            <Fragment>The phone number 937663 is derived from <a href="https://en.wikipedia.org/wiki/Phoneword" target="_blank" rel="noopener noreferrer">Phoneword</a> "wesone"</Fragment>
        ]
    },
    PROJECTS_PROJECT_Aments_of_Bayside: {
        LOGLINE: <Fragment>
            <p>
                Rick and Susan DeLorean take a vacation to relax from their stressful everyday lives.
                They have rented a holiday apartment for a week for this purpose, which they found on the Internet.
            </p>
            <p>
                However, their holiday will not be what they expected...
            </p>
        </Fragment>,
        TRIVIA: [
            'The film was "on hold" for a long time until it was released on October 26th 2012',
            'The ending of the film was improvised at the last moment'
        ]
    },
    PROJECTS_PROJECT_Bad_Moon_Rising: {
        LOGLINE: <Fragment>
            <p>
                There hasn't been a raindrop in Los Santos for weeks.
                Instead, there is great heat, which makes any desire for activity wilt.
            </p>
            <p>
                Dean Wood (Deadwood) and John Castle (wesone) are two good friends, who are also suffering from the heat...
                But then "day 1" begins, when the drought ends.
            </p>
        </Fragment>,
        TRIVIA: [
            'Originally a completely different ending was planned, in which John and Dean make their way to "Mount Chiliad" with other survivors',
            'The name "Dean Wood" is derived from Deadwood',
            'At 6:15 in the movie, Dean pees on a patrol car, which reflects a kind of "trademark" of INM'
        ]
    },
    PROJECTS_PROJECT_The_Parody: {
        LOGLINE: <Fragment>
            <p>
                This is a little parody, but it should not be taken too seriously!
            </p>
        </Fragment>,
        TRIVIA: [
            '"The Parody" is a parody of a YouTuber who used various ideas from the "INM Comedy Show" (without permission) in his videos. INM was not angry, but they didn\'t want to leave this unanswered. They asked if they could do a little parody... with success',
            'First it was planned to publish several parodies of the YouTuber in the next "INM Comedy Show", but then too many ideas came up, so that there would have been no room for other sketches. So INM wanted to do an "INM Comedy Show Special", but finally they decided to make a completely different movie... "The Parody"'
        ]
    },
    PROJECTS_PROJECT_Unlocked_and_Loaded: {
        LOGLINE: <Fragment>
            <p>
                It's Friday morning and there is the after-show party...
            </p>
            <p>
                What INM doesn't know yet is that it's gonna be a long Friday...
            </p>
        </Fragment>,
        TRIVIA: [
            'The idea for this film came from wesone',
            'SergeiVodkakov is not starring in this film',
            'Jacqui was not yet on the team at that time'
        ]
    },
    PROJECTS_PROJECT_The_Dosshouse: {
        LOGLINE: <Fragment>
            <p>
                Wesley Walker and Walter Kingsley are old friends.
                They knew each other since before college.
                After a long time, they decide to meet again in a little bar.
                It's getting late and the bar is empty.
                In the middle of the night, they decide to go home...
            </p>
            <p>
                But that's where the problems start...
            </p>
        </Fragment>,
        TRIVIA: [
            'The Dosshouse takes up the splatter cliché, but is not based on any film and does not refer to any real film'
        ]
    },
    PROJECTS_PROJECT_Rolling_Dope: {
        LOGLINE: <Fragment>
            <p>
                Dean Simmons and Brian O'Neil are two badly paid truckers who work for the beer producer Fleischberg.
                When they deliver to a not quite legal company, disaster takes its course.
            </p>
        </Fragment>,
        TRIVIA: [
            'Rolling Dope was the first film from INM in Full HD and Widescreen',
            'The direct sequel "Rolling Dope 2" was released much later',
            'In Rolling Dope SergejVodkakov starred for the first time, but not with his skin. He only carries his name and plays the owner of Fleischberg',
            'Since Rolling Dope it is kind of a trademark that people pee in the movies of INM'
        ]
    },
    PROJECTS_PROJECT_Die_INM_Comedy_Show: {
        LOGLINE: <Fragment>
            <p>
                The INM Comedy Show was intended as a special to celebrate a milestone in the number of subscribers.
                The show was enjoyed by a wide audience, which is why there were new parts of the Comedy Show later on.
            </p>
            <p>
                In each part wesone and killerman lead through the show at a new location, which then consists of various small comedy scenes.
            </p>

            <p>
                <h5>Part 1 - 02/19/2010</h5>
                was the 200 subscribers special and the beginning of the comedy show.
                The setting is a baseball field in San Fierro.
            </p>
            <p>
                <h5>Part 2 - 06/26/2010</h5>
                was the 300 subscribers special.
                This part is set at the train station in San Fierro.
            </p>
            <p>
                <h5>Part 3 - 02/19/2011</h5>
                did not arrive on time with 600 subscribers, so it served as a 650 subscriber special.
                The location is on the "Gant Bridge", which separates San Fierro and Tierra Robada.
            </p>
            <p>
                <h5>Part 4 - 02/16/2013</h5>
                celebrated the 1000 subscribers and is the last part so far.
                It is set in wesone\'s Infernus, with which the "narrators" travel from Los Santos, over to San Fierro, and finally to Las Venturas.
            </p>
        </Fragment>,
        TRIVIA: [
            'The INM Comedy Show was created by killerman and wesone. They write the sketches and jokes'
        ]
    },
    PROJECTS_PROJECT_Desert_Homicide: {
        LOGLINE: <Fragment>
            <p>
                John Derek and Thomas Sullivan are two cops from Las Venturas.
                They have been partners for a long time and often patrol, but what they experience today is anything but a normal working day.
            </p>
        </Fragment>,
        TRIVIA: [
            'Until the end it remains open whether Thomas is still alive or dead',
            'A sequel is not planned'
        ]
    },
    PROJECTS_PROJECT_WTC_9_11_2001: {
        // LOGLINE: ,
        TRIVIA: [
            'The idea for the film came from killerman alone'
        ]
    },
    PROJECTS_PROJECT_Restless_Survivors: {
        LOGLINE: <Fragment>
            <p>
                Roman Colusso and Nick McCarthy live in a world that is not for the faint of heart.
                Their goal is to survive!
            </p>
            <p>
                <h5>Part 2 - 08/20/2009</h5>
                To reach the saving city of Sun Wes City, Roman and Nick have to make a small detour.
            </p>
            <p>
                <h5>Part 3 - 12/29/2009</h5>
                See how it all began. Team Sierra is called in to stop the epidemic.
            </p>
            <p>
                <h5>Part 4 - 07/28/2011</h5>
                After one year, 6 months, 29 days, 22 hours and 2 minutes, "Restless Survivors" was continued and finished...
                A historic day.
            </p>
        </Fragment>,
        TRIVIA: [
            'Restless Survivors includes a series of 4 films',
            'After Restless Survivors was pirated several times, Restless Survivors III was the first film in which wesone included a ©-sign (copyright)',
            'Only after one year, 6 months, 29 days, 22 hours and 2 minutes after Restless Survivors III was released, Restless Survivors IV was published',
            'The end of Restless Survivors IV was originally right after the explosion of the bomb, but that was changed again and now Roman is taking revenge on Dr. Dublin after the explosion'
        ]
    },
}
